import { render, staticRenderFns } from "./PpvModalHeader.vue?vue&type=template&id=2990d80c&scoped=true"
import script from "./PpvModalHeader.vue?vue&type=script&lang=js"
export * from "./PpvModalHeader.vue?vue&type=script&lang=js"
import style0 from "./PpvModalHeader.vue?vue&type=style&index=0&id=2990d80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2990d80c",
  null
  
)

export default component.exports